import React from 'react';
import { API_URL } from '../config';
import './ServerList.css';

function ServerList({ servers, currentServer, onSelectServer, onAddServer, onHomeClick, showMobile, pendingFriendRequestsCount = 0, dmUnreadCount = 0, isAdmin = false, onAdminClick, onGamingHubClick }) {
  const totalNotifications = pendingFriendRequestsCount + dmUnreadCount;
  
  return (
    <div className={`server-list ${showMobile ? 'mobile-visible' : ''}`}>
      <div className="server-list-scroll">
        <div 
          className="server-icon home"
          title="Home"
          onClick={onHomeClick}
        >
          {/* Ripkord logo - sound waves symbolizing communication */}
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
            {/* Center dot (sound source) */}
            <circle cx="16" cy="16" r="3" fill="white"/>
            {/* Sound wave 1 - small */}
            <circle cx="16" cy="16" r="7" stroke="white" strokeWidth="2.5" fill="none" opacity="0.8"/>
            {/* Sound wave 2 - medium */}
            <circle cx="16" cy="16" r="11" stroke="white" strokeWidth="2" fill="none" opacity="0.5"/>
            {/* Sound wave 3 - large */}
            <circle cx="16" cy="16" r="14.5" stroke="white" strokeWidth="1.5" fill="none" opacity="0.3"/>
          </svg>
          {totalNotifications > 0 && (
            <div className="notification-badge">{totalNotifications > 99 ? '99+' : totalNotifications}</div>
          )}
        </div>

        <div className="server-separator"></div>

        {servers.map(server => (
          <div
            key={server.id}
            className={`server-icon ${currentServer?.id === server.id ? 'active' : ''}`}
            onClick={() => onSelectServer(server)}
            title={server.name}
          >
            {server.avatar_url ? (
              <img 
                src={`${API_URL}${server.avatar_url}`} 
                alt={server.name} 
                className="server-avatar-img"
              />
            ) : (
              server.name.substring(0, 2).toUpperCase()
            )}
          </div>
        ))}

        <div 
          className="server-icon add-server"
          title="Add a Server"
          onClick={onAddServer}
        >
          +
        </div>

        {isAdmin && (
          <>
            <div className="server-separator"></div>
            <div 
              className="server-icon gaming-hub-icon"
              title="Gaming Hub"
              onClick={onGamingHubClick}
            >
              🎮
            </div>
            <div 
              className="server-icon admin-icon"
              title="Admin Dashboard"
              onClick={onAdminClick}
            >
              ⚙️
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default ServerList;
